/**
 * Strip HTML tags + decode common HTML entities, optionally truncate.
 * Use for card previews where rich-text descriptions should display as plain text.
 *
 * @param {string} html - HTML string from rich-text editor
 * @param {number} maxLength - Truncate to this many chars (default 150). Pass 0 for no truncation.
 * @returns {string} clean text
 */
export function stripHtml(html, maxLength = 150) {
  if (!html || typeof html !== 'string') return '';
  // Use the browser parser for safe and accurate stripping
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const text = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  if (maxLength > 0 && text.length > maxLength) {
    return text.slice(0, maxLength).trimEnd() + '…';
  }
  return text;
}
